// in src/MyAppBar.js
import * as React from 'react';
import { AppBar, Button, Login, Logout, UserMenu, useGetIdentity } from 'react-admin';
import Typography from '@mui/material/Typography';
import {
    ListItemIcon,
    ListItemText,
    MenuItem,
    useMediaQuery,
} from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import {useNavigate} from 'react-router-dom';

import logo from '../logo.svg';

const ProfileButton = () => {
    const { isLoading, error, data, refetch } = useGetIdentity();
    const navigate = useNavigate();

    if(isLoading || !data) {
        return null;
    }

    return (
        <MenuItem onClick={() => {navigate(`/users/${data.id}`)}}>
            <ListItemIcon>
                {/* {icon ? icon : <ExitIcon fontSize="small" />} */}
                <ManageAccountsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
                Account
                {/* {translate('ra.auth.logout', { _: 'Logout' })} */}
            </ListItemText>
        </MenuItem>
    )
};

const NmsUserMenu = (props) => {
    // auth
    return (
        <UserMenu>
            <ProfileButton/>
            <Logout/>
        </UserMenu>
    );
};

const NmsAppBar = (props) => (
    <AppBar
        color='default'
        elevation={0}
        userMenu={<NmsUserMenu/>}
        sx={{
            // boxShadow: 1,
            "& .RaAppBar-title": {
                flex: 1,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
            },
        }}
        {...props}
    >
        <div style={{flex: 1, textAlign: 'center'}}>
        {/*
        <Typography
            variant="h6"
            color="inherit"
            // className={classes.title}
            id="react-admin-title"
        />
        */}
        <img src={logo} style={{height: '30px'}} className="App-logo" alt="logo" />
        {/* <span className={classes.spacer} /> */}
        </div>
    </AppBar>
);

export default NmsAppBar;
